(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.coInitialized) return;
    root.dataset.coInitialized = 'true';
    var videoDialog = root.querySelector('[data-tu-video-dialog]');
    var videoStage = root.querySelector('[data-tu-video-stage]');
    var videoHeading = root.querySelector('[data-tu-video-heading]');
    var videoNote = root.querySelector('[data-tu-video-note]');
    var closeVideo = root.querySelector('[data-tu-video-close]');
    var videoTrigger;
    // One click-created Vimeo frame, removed on every close to stop playback.
    // Normalize both public and unlisted URLs; never embed arbitrary hosts.
    function vimeoEmbed(value) {
      try {
        var url = new URL(value);
        if (url.protocol !== 'https:') return null;
        var match;
        if (url.hostname === 'vimeo.com' || url.hostname === 'www.vimeo.com') {
          match = url.pathname.match(/^\/(\d+)(?:\/([a-zA-Z0-9]+))?\/?$/);
        } else if (url.hostname === 'player.vimeo.com') {
          match = url.pathname.match(/^\/video\/(\d+)\/?$/);
        }
        if (!match) return null;
        var embed = new URL('https://player.vimeo.com/video/' + match[1]);
        var hash = url.searchParams.get('h') || match[2];
        if (hash && /^[a-zA-Z0-9]+$/.test(hash)) embed.searchParams.set('h', hash);
        embed.searchParams.set('autoplay', '1');
        embed.searchParams.set('playsinline', '1');
        embed.searchParams.set('title', '0');
        embed.searchParams.set('byline', '0');
        embed.searchParams.set('portrait', '0');
        return embed.href;
      } catch (error) { return null; }
    }
    if (videoDialog && typeof videoDialog.showModal === 'function' && videoStage && videoHeading && videoNote && closeVideo) {
      root.querySelectorAll('[data-tu-video-url]').forEach(function (trigger) {
        var source = vimeoEmbed(trigger.dataset.tuVideoUrl);
        if (!source) return;
        trigger.disabled = false;
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.addEventListener('click', function () {
          videoTrigger = trigger;
          var title = trigger.dataset.tuVideoTitle;
          videoDialog.classList.toggle('tu-video-dialog-4x3', trigger.dataset.tuVideoAspect === '4:3');
          videoHeading.textContent = title;
          videoNote.textContent = trigger.hasAttribute('data-tu-video-sample')
            ? 'Preview: this slot uses the sample lesson from our promo pages. The final walkthrough will replace it before publication.'
            : 'Close the video to return to your place on the page.';
          videoStage.replaceChildren();
          var frame = document.createElement('iframe');
          frame.title = trigger.hasAttribute('data-tu-video-sample') ? 'Sample Kesler CPA Review lesson' : title;
          frame.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          videoDialog.showModal();
          frame.src = source;
          videoStage.appendChild(frame);
          closeVideo.focus();
        });
      });
      closeVideo.addEventListener('click', function () { videoDialog.close(); });
      videoDialog.addEventListener('click', function (event) {
        var box = videoDialog.getBoundingClientRect();
        if (event.target === videoDialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) videoDialog.close();
      });
      videoDialog.addEventListener('close', function () {
        videoStage.replaceChildren();
        if (videoTrigger && videoTrigger.isConnected) videoTrigger.focus({ preventScroll: true });
      });
    }
    var lightbox = root.querySelector('[data-tu-lightbox]');
    var lightboxImage = root.querySelector('[data-tu-lightbox-image]');
    var lightboxCaption = root.querySelector('[data-tu-lightbox-caption]');
    var closeImage = root.querySelector('[data-tu-close]');
    var zoomImage = root.querySelector('[data-tu-zoom]');
    var imageTrigger;
    if (lightbox && typeof lightbox.showModal === 'function' && lightboxImage && lightboxCaption && closeImage && zoomImage) {
      root.querySelectorAll('[data-tu-enlarge]').forEach(function (trigger) {
        trigger.disabled = false;
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          var thumbnail = trigger.querySelector('img');
          if (!thumbnail) return;
          imageTrigger = trigger;
          lightboxImage.src = trigger.dataset.tuImageSrc;
          lightboxImage.alt = thumbnail.alt;
          lightboxImage.width = Number(thumbnail.getAttribute('width'));
          lightboxImage.height = Number(thumbnail.getAttribute('height'));
          lightbox.style.setProperty('--tu-image-width', lightboxImage.width + 'px');
          var caption = trigger.closest('figure').querySelector('figcaption');
          lightboxCaption.textContent = caption ? caption.textContent.replace('Tap image to enlarge.', '').trim() : thumbnail.alt;
          lightbox.classList.remove('tu-lightbox-zoomed');
          zoomImage.setAttribute('aria-pressed', 'false');
          zoomImage.textContent = 'Zoom in';
          lightbox.showModal();
          lightbox.querySelector('.tu-lightbox-scroll').scrollTo(0, 0);
          closeImage.focus();
        });
      });
      closeImage.addEventListener('click', function () { lightbox.close(); });
      lightbox.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        var first = zoomImage;
        var last = lightbox.querySelector('.tu-lightbox-scroll');
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
      zoomImage.addEventListener('click', function () {
        var zoomed = lightbox.classList.toggle('tu-lightbox-zoomed');
        zoomImage.setAttribute('aria-pressed', String(zoomed));
        zoomImage.textContent = zoomed ? 'Fit image' : 'Zoom in';
      });
      lightbox.addEventListener('click', function (event) {
        var box = lightbox.getBoundingClientRect();
        if (event.target === lightbox && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) lightbox.close();
      });
      lightbox.addEventListener('close', function () {
        if (imageTrigger && imageTrigger.isConnected) imageTrigger.focus({ preventScroll: true });
      });
    }
    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      var target = id && root.querySelector('#' + CSS.escape(id));
      if (target && target.tagName === 'DETAILS') target.open = true;
    });
  }
  document.querySelectorAll('[data-course-overview]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-course-overview]').forEach(init); });
})();
